import { BOARD_TF_OPTIONS } from '../../utils/eodChartMath';

/**
 * TradingView-style top chart header:
 * symbol · interval · Indicators · Alert · Replay · undo/redo · layout actions
 */
export default function TvTopBar({
  symbolLabel = 'NIFTY',
  symbols = [],
  onSymbolChange,
  tf,
  onTfChange,
  showFib,
  onToggleFib,
  onRefresh,
  isRefreshing,
  dataSourceLabel = '',
  onUndo,
  onRedo,
  canUndo = false,
  canRedo = false,
  exch = 'NSE',
  onExchChange,
}) {
  return (
    <header className="tv-top-bar">
      <div className="tv-top-left">
        <div className="tv-symbol-search">
          <i className="bi bi-search tv-search-ico" />
          <select
            className="tv-symbol-select"
            value={symbolLabel}
            onChange={(e) => onSymbolChange?.(e.target.value)}
            title="Symbol"
          >
            {symbols.map((s) => (
              <option key={s.id} value={s.label}>{s.label}</option>
            ))}
          </select>
        </div>

        <div className="tv-interval-group">
          {BOARD_TF_OPTIONS.filter((o) => !o.eod).slice(0, 6).map((o) => (
            <button
              key={o.value}
              type="button"
              className={`tv-interval-btn${tf === o.value ? ' active' : ''}`}
              onClick={() => onTfChange?.(o.value)}
            >
              {o.label.replace(' min', '').replace(' hour', 'H').replace('1 hour', '1H')}
            </button>
          ))}
          <select
            className="tv-interval-more"
            value={BOARD_TF_OPTIONS.some((o) => o.value === tf) ? tf : '5m'}
            onChange={(e) => onTfChange?.(e.target.value)}
            title="Interval"
          >
            <optgroup label="Intraday">
              {BOARD_TF_OPTIONS.filter((o) => !o.eod).map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </optgroup>
            <optgroup label="EOD">
              {BOARD_TF_OPTIONS.filter((o) => o.eod).map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </optgroup>
          </select>
        </div>

        <div className="tv-top-sep" />

        <button type="button" className="tv-top-btn" title="Indicators">
          <i className="bi bi-graph-up" /> Indicators
        </button>
        <button
          type="button"
          className={`tv-top-btn${showFib ? ' active' : ''}`}
          title="Auto Fib"
          onClick={onToggleFib}
        >
          <i className="bi bi-distribute-vertical" /> Fib
        </button>
        <button type="button" className="tv-top-btn" title="Alert">
          <i className="bi bi-bell" /> Alert
        </button>
        <button type="button" className="tv-top-btn" title="Bar replay">
          <i className="bi bi-play-circle" /> Replay
        </button>
      </div>

      <div className="tv-top-right">
        <select
          className="tv-exch-select"
          value={exch}
          onChange={(e) => onExchChange?.(e.target.value)}
          title="Exchange"
        >
          <option value="NSE">NSE</option>
          <option value="BSE">BSE</option>
        </select>

        <button
          type="button"
          className="tv-icon-btn"
          title="Undo"
          disabled={!canUndo}
          onClick={onUndo}
        >
          <i className="bi bi-arrow-counterclockwise" />
        </button>
        <button
          type="button"
          className="tv-icon-btn"
          title="Redo"
          disabled={!canRedo}
          onClick={onRedo}
        >
          <i className="bi bi-arrow-clockwise" />
        </button>
        <button
          type="button"
          className="tv-icon-btn"
          title="Refresh"
          disabled={isRefreshing}
          onClick={onRefresh}
        >
          <i className={`bi bi-arrow-repeat${isRefreshing ? ' tv-spin' : ''}`} />
        </button>
        {dataSourceLabel && (
          <span className="tv-source-pill" title="Data source">{dataSourceLabel}</span>
        )}
      </div>
    </header>
  );
}
